module.exports = __webpack_public_path__ + "img/能源管理系统_02.3dc29b7a.png";